import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import enMessages from './locales/en.json';
import frMessages from './locales/fr.json';
import deMessages from './locales/de.json';

const messages = {
  en: enMessages,
  fr: frMessages,
  de: deMessages,
};

const browserLocale = navigator.language.split('-')[0]; // Extrait "en" de "en-US"
const defaultLocale = browserLocale in messages ? browserLocale : 'en';

const IntlProviderWrapper = ({ children }) => {
  const [locale] = useState(defaultLocale);

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  );
};

export default IntlProviderWrapper;
